<meta name="app-version" content="{{ appVersion }}" hidden />
<app-toasts></app-toasts>
<div
  [ngStyle]="{ opacity: opacityChange, transition: splashTransition, display: splashdisplay }"
  class="splash-screen">
  <img [attr.src]="loaderLogo" alt="Logo" />
  <span class="loader" role="status"></span>
  <span *ngIf="loaderMessage">{{ loaderMessage }}</span>
</div>
<router-outlet></router-outlet>
